import { withTranslation } from "next-i18next";
import { useRouter } from "next/compat/router";
import ahoy from "@lib/ahoy";
import { useCurrentUser } from "@hooks/use-current-user";
import { productClickedEvent } from "@utils/events/product-events";
import ProductImageLink from "../Shared/ProductImageLink";
import ProductLike from "../Shared/ProductLike";

function ProductSuggestionCard({
  product,
  context,
  metaAlgolia = {},
  isLook = false,
  position,
  t,
}) {
  const router = useRouter();
  const user = useCurrentUser();

  function handleClick() {
    ahoy("$click", {
      name: isLook ? "suggestions-look" : "suggestions-similar",
      slug: product.slug,
    });

    if (!isLook && metaAlgolia) {
      productClickedEvent(
        {
          algolia: metaAlgolia,
          position,
          objectID: product.objectID,
          userToken: user?.uid,
        },
        "similarProductClicked",
      );
    }
  }

  return (
    <div className="product-suggestion">
      <div className="product-suggestion-image">
        <ProductImageLink
          algolia={metaAlgolia}
          product={product}
          onClick={handleClick}
          context={context}
        />

        {isLook && (
          <div className="look-badge">
            <span className="text-white font-size-xs font-weight-bold">
              {t("product:look_badge")}
            </span>
          </div>
        )}

        <ProductLike
          product={product}
          className="like-btn"
        />
      </div>

      <div className="product-suggestion-info">
        <h6 className="mb-0 catalog-product-name">
          {isLook || router.locale === router.defaultLocale
            ? product.name
            : product[`name_${router.locale.toLowerCase()}`]}
        </h6>
        <p className="mb-0 catalog-product-brand text-gray">
          {isLook ? product.brand_name : product.brand.name}
        </p>
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductSuggestionCard);
